import { render } from "./EventsDrawer.vue?vue&type=template&id=e95dba34&scoped=true"
import script from "./EventsDrawer.vue?vue&type=script&lang=js"
export * from "./EventsDrawer.vue?vue&type=script&lang=js"

import "./EventsDrawer.vue?vue&type=style&index=0&id=e95dba34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e95dba34"]])

export default __exports__